
import React from 'react';
import { connect } from 'react-redux';
import Item from 'components/Item/Item/Item';
import * as ConfigTypes from 'config/ConfigTypes';
import { injectIntl } from 'react-intl';
import { Flow } from 'flow-react';
import { observer } from 'mobx-react';

import * as actions from 'store/actions';

import './ItemList.scss';

const ItemList = observer(
    class ItemList extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                itemlist: []
            }
        }

        updateItemList = () => {
            const { itemlist } = this.props.mediaObjects;
            if (itemlist) {
                this.setState({ itemlist: itemlist, loading: true }, () => this.setState({ loading: false }));
            }
        }

        showItemList = (item, i) => {
            if (this.props.mediaObjects.wpView == ConfigTypes.WORK_LIST) {
                return (<Item key={`itemlistCard_${i}`} item={item} />)
            }
            return (
                <div key={`itemlist_${i}`} className="col-xxl-3 col-xl-4 col-lg-4 col-md-6">
                    <Item key={`itemlistCard_${i}`} item={item} />
                </div>)
        }

        showList = () => {
            const { currentWork } = this.props.mediaObjects;
            if (this.props.mediaObjects.wpView == ConfigTypes.WORK_LIST) {
                if (currentWork && currentWork.manifests && currentWork.manifests.length) {
                    return currentWork.manifests.map((manifest, i) => {
                        let curList = this.state.itemlist.filter(item => item.manifest == manifest.prid);
                        let isEmpty = (curList && curList.length) ? false : true;
                        if (manifest.directory && manifest.prid) return (
                            <div key={`itemlist_${i}`}>
                                {!isEmpty && <div className="itemlist-manifest">
                                    {this.props.intl.formatMessage({ id: `itemlist.${manifest.directory.toLowerCase()}` })}
                                </div>}
                                {!isEmpty && curList.map((item, i) => this.showItemList(item, i))}
                            </div>
                        )
                    })
                }
            }
        }

        componentDidUpdate(prev) {
            if (prev.mediaObjects.itemlist != this.props.mediaObjects.itemlist) {
                this.updateItemList();
            }
        }

        componentDidMount() {
            this.updateItemList();
        }

        render() {
            return (
                <div className="itemlist p-0">
                    {!this.state.loading && this.showList()}
                </div>
            )
        }
    }
)

const mapStateToProps = (state) => ({
    mediaObjects: state.media.mediaObjects
});

const mapDispatchToProps = (dispatch) => ({
    updateMediaObjects: (obj) => dispatch(actions.updateMediaObjects(obj)),
    updateAppObjects: (obj) => dispatch(actions.updateAppObjects(obj)),
})

export default Flow.injectFlow(connect(mapStateToProps, mapDispatchToProps)(injectIntl(ItemList)));